import React, { useContext } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RHFLegacyField from '#component/form/rhf/rhf-legacy-field';
import CheckBox from '#component/form/checkbox';
import { ErrorsContext } from '#component/project/form/error-context';
import {
  FieldCnt,
  PanelDetails,
  PanelSummary,
  StyledAccordion,
  StyledAvatar,
  StyledField,
  StyledTitle,
  TitleContainer
} from './styles';
import ProductItemActions from './product-item-actions';
import propTypes from './prop-types';

const normalizeCheckBoxField = value => (value ? 1 : 0);

/**
 * Renders MUI expansion panel with product item fields.
 * Contains button to remove product-item.
 * @returns {React.FC}
 */

const ProductItem = props => {
  const {
    index,
    member,
    remove,
    expanded,
    handleSetExpanded,
    item,
    forceError
  } = props;
  const { control } = useFormContext();
  const { errors, setErrors } = useContext(ErrorsContext);

  const handlePanelClick = () => {
    if (errors.products?.[index]) {
      const untouchedErrors = [...errors.products];
      untouchedErrors[index] = false;
      setErrors(s => ({ ...s, products: untouchedErrors }));
    }
  };

  const deleteProductItem = event => {
    event.stopPropagation();
    remove(index);
  };

  return (
    <StyledAccordion
      hasError={!!errors.products?.[index]}
      expanded={expanded}
      onChange={handleSetExpanded(member)}
      onClick={handlePanelClick}
    >
      <PanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index + 1}a-content`}
        id={`panel${index + 1}a-header`}
      >
        <TitleContainer>
          <StyledAvatar>{index + 1}</StyledAvatar>
          <StyledTitle>{item.label}</StyledTitle>
        </TitleContainer>
        <ProductItemActions deleteProductItem={deleteProductItem} />
      </PanelSummary>
      <PanelDetails>
        <RHFLegacyField
          name={`${member}.label`}
          component={StyledField}
          placeholder="Product name"
          variant="outlined"
          forceError={forceError}
        />
        <FieldCnt>
          <Controller
            name={`${member}.fragile`}
            control={control}
            render={({ field }) => (
              <CheckBox
                label="FRAGILE"
                checked={Boolean(field.value)}
                onChange={e => field.onChange(normalizeCheckBoxField(e.target.checked))}
              />
            )}
          />
          <Controller
            name={`${member}.hazmat`}
            control={control}
            render={({ field }) => (
              <CheckBox
                label="HAZMAT"
                checked={Boolean(field.value)}
                onChange={e => field.onChange(normalizeCheckBoxField(e.target.checked))}
              />
            )}
          />
        </FieldCnt>
      </PanelDetails>
    </StyledAccordion>
  );
};

ProductItem.propTypes = propTypes;

export default ProductItem;
